import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { loginApiService, LoginVieEM, verifyOtp } from '../api/loginApiService';
import '../styles/Login.css';
import { CustomSwal, isValidEmail, isValidMobile, showOtpPrompt } from '../services/customSwal';
import appConfig from '../config/appConfig';

const Login: React.FC = () => {
  const [UserName, setUserName] = useState('');
  const [Password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isEmailMobileChecked, setIsEmailMobileChecked] = useState(false);
  const navigate = useNavigate();

  const otpVerify = ['N', 'E', 'M', 'W'].includes(appConfig.OtpVerify) ? appConfig.OtpVerify : 'N';
  const otpLogin = ['M', 'W'].includes(appConfig.OtpVerify) ? appConfig.OtpVerify : 'M';

  const handleOTPLogin = async (receiver: string) => {
    try {
      if (!receiver.trim()) {
        setError('Enter email or mobile number');
        return;
      }

      const isMobile = /^\d+$/.test(receiver);
      const isEmail = /^[^\s@]+@[^\s@]+\.(com|in|edu)$/i.test(receiver);

      if (!isMobile && !isEmail) {
        setError('Enter valid mobile or valid email');
        return;
      }

      const payload = isMobile ? { mobile: receiver } : { email: receiver };
      const response = await LoginVieEM(payload, otpLogin);
      switch (response?.Result) {
        case '0':
          setError(response.Message);
          break;
        case '1':
          if (response.OtpResponse && response.OtpResponse.length > 0 && response.OtpResponse[0].status === "1") {
            const mobile = response?.Mobile || '';
            const email = response?.EmailId || '';
            const staff_id = response?.User || '';
            // Decide which masked value to show in OTP prompt
            let otpReceiver = '';
            if (isMobile && mobile) otpReceiver = mobile;
            else if (isEmail && email) otpReceiver = email;

            let attempts = 0;
            let verified = false;

            while (attempts < 3 && !verified) {
              const otp = await showOtpPrompt(otpReceiver);

              if (!otp) break; // user cancelled prompt

              const verifyRes = await verifyOtp(payload, otp, staff_id);

              if (verifyRes?.verified) {
                verified = true;
                await CustomSwal.fire('Success', 'OTP verified & login success', 'success');
                navigate('/Home');
              } else {
                attempts++;
                if (attempts < 3) {
                  await CustomSwal.fire('Invalid OTP', `Attempt ${attempts}/3 - Please try again`, 'error');
                }
              }
            }

            if (!verified) {
              sessionStorage.clear();
              await CustomSwal.fire('Verification Required', 'Please verify your account to continue login.', 'warning');
            }
          } else {
            await CustomSwal.fire('Time Out', 'Please try again after 5 minutes', 'warning');
          }

          break;
        case '2':
          CustomSwal.fire('Account Locked', 'Please contact the administrator to unlock your account.', 'warning');
          setError('Account is locked');
          break;
        default:
          setError('Invalid login credentials');
      }
    } catch (err: any) {
      console.error("Login failed:", err);
      setError("Please check the API.");
    }
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setError('');

    if (!UserName.trim()) {
      setError(isEmailMobileChecked ? 'Email or Mobile is required' : 'Username is required');
      return;
    }

    if (isEmailMobileChecked) {
      const isOnlyNumber = /^\d+$/.test(UserName);
      if (isOnlyNumber && !isValidMobile(UserName)) {
        setError('Enter a valid 10-digit mobile number');
        return;
      } else if (!isOnlyNumber && !isValidEmail(UserName)) {
        setError('Enter a valid email address');
        return;
      }
      await handleOTPLogin(UserName);
    } else {
      if (!Password.trim()) {
        setError('Enter Password');
        return;
      }

      try {
        const response = await loginApiService(UserName, Password, otpVerify);
       
        switch (response?.Result) {
          case '0':
            setError(response.Message);
            break;
          case '1':
            const mobile = response?.Mobile || '';
            const email = response?.EmailId || '';
            const staff_id = response?.User || '';

            if (otpVerify === 'N') {
              navigate('/Home');
              return;
            }

            // Decide payload + masked receiver for UI
            let payload: { mobile?: string; email?: string } = {};
            let receiver = '';

            if (otpVerify === 'M') {
              payload = { mobile };
              receiver = mobile;
            } else if (otpVerify === 'E') {
              payload = { email };
              receiver = email;
            } else if (otpVerify === 'W') {
              payload = { mobile };
              receiver = mobile;
            }

         

            if (response.OtpResponse && response.OtpResponse.length > 0 && response.OtpResponse[0].status === "1") {
              let attempts = 0;
              let verified = false;

              while (attempts < 3 && !verified) {                

                const otp = await showOtpPrompt(receiver);

                if (!otp) break; // user cancelled prompt

                const verifyRes = await verifyOtp(payload, otp, staff_id);

                if (verifyRes?.verified) {
                  verified = true;
                  await CustomSwal.fire('Success', 'OTP verified & login success', 'success');
                  navigate('/Home');
                } else {
                  attempts++;
                  if (attempts < 3) {
                    await CustomSwal.fire('Invalid OTP', `Attempt ${attempts}/3 - Please try again`, 'error');
                  }
                }
              }

              if (!verified) {
                sessionStorage.clear();
                await CustomSwal.fire('Verification Required', 'Please verify your account to continue login.', 'warning');
              }
            } else {
              await CustomSwal.fire('Time Out', 'Please try again after 5 minutes', 'warning');
            }
            break;
          case '2':
            CustomSwal.fire('Account Locked', 'Please contact the administrator to unlock your account.', 'warning');
            setError('Account is locked');
            break;
          default:
            setError('Invalid login credentials');
        }
      } catch (err: any) {
        console.error("Login failed:", err);
        setError("Please check the API.");
      }
    }
  };

  return (
    <div className="LogInfull-background">
      <video autoPlay muted loop playsInline className="bg-video">
        <source src="/assets/BgVideo.mp4" type="video/mp4" />
      </video>
      {/* <div className="overlay-gradient"></div> */}

      <div className="left-text">
        <h1>PSG-ERP</h1>
        {/* <img src="/assets/HRMLogo1.png" alt="HRM Logo" className="hrm-logo" /> */}
      </div>
      {/* <div className="left-text">
        <video autoPlay muted loop playsInline className="left-video">
          <source src="/assets/leftlogin.mp4" type="video/mp4" />
        </video>
      </div> */}

      <div className="login-card">
        <div className="login-header-bar">
          <h4 className="login-title">PSG Institutions</h4>
        </div>

        <form onSubmit={handleLogin} noValidate className='loginForm' autoComplete="off">
          <div className={`input-group ${submitted && !UserName ? 'invalid' : ''}`}>
            <i className={`fas ${isEmailMobileChecked ? 'fa-envelope' : 'fa-user'}`}></i>
            <input
              type="text"
              placeholder={isEmailMobileChecked ? 'Email or Mobile' : 'Login ID'}
              value={UserName}
              onChange={(e) => {
                let val = e.target.value;

                if (!isEmailMobileChecked) {
                  // Login ID: letters, numbers, underscore only
                  val = val.replace(/[^\w]/g, '');
                } else {
                  // Email/Mobile: remove invalid characters for numbers, allow @ . _ - for emails
                  // First check if it looks like a number (only digits)
                  if (/^\d*$/.test(val)) {
                    // Only digits allowed for mobile
                    val = val.slice(0, 10); // max 10 digits for mobile
                  } else {
                    // For email, allow letters, numbers, @, ., _, -
                    val = val.replace(/[^\w@.-]/g, '');
                  }
                }

                setUserName(val);
                setError('');
                if (submitted) setSubmitted(false);
              }}
              autoComplete="username"
            />

          </div>

          {!isEmailMobileChecked && (
            <div className={`input-group ${submitted && !Password ? 'invalid' : ''}`} style={{ position: 'relative' }}>
              <i className="fas fa-lock"></i>
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                value={Password}
                onChange={(e) => {
                  const value = e.target.value.replace(/\s/g, ''); // remove all spaces
                  setPassword(value);
                  setError('');
                  if (submitted) setSubmitted(false);
                }}
                autoComplete="current-password"
                style={{ paddingRight: '2rem' }}
              />
              <i
                className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} toggle-password`}
                onClick={() => setShowPassword(!showPassword)}
              ></i>
            </div>
          )}

          {error && <span className="text-danger1">{error}</span>}

          <div className="LoginType">
            {/* 🔹 Replace checkbox with link */}
            <span
              className="toggle-login-mode"
              onClick={() => {
                setIsEmailMobileChecked(!isEmailMobileChecked);
                setUserName('');
                setPassword('');
                setError('');
                setSubmitted(false);
              }}
              style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
            >
              {isEmailMobileChecked
                ? 'Login with Login ID & Password'
                : 'Login with Email / Mobile'}
            </span>
          </div>

          <button type="submit" className="login-btn">
            Login
          </button>

          {/* 🔹 Forgot password moved below button */}
          {!isEmailMobileChecked && (
            <div className="forgot-password">
              <Link to="/forgotpassword">Forgot Password?</Link>
            </div>
          )}

          <div className="signup-link">
            Don’t have an account? <Link to="/signup">Create New account</Link>
          </div>
        </form>
        <footer className="login-footer">
          <p>&copy; 2025 Powered by PSG Software Technologies</p>
        </footer>
      </div>
    </div>
  );
};

export default Login;
